<template>
    <v-dialog v-model="visible" max-width="500" @click:outside="onDismiss" @keydown.esc="onDismiss">
        <v-card v-if="corrente">
            <v-card-title>Richiesta di abbinamento</v-card-title>
            <v-card-text>
                <p>
                    <strong>{{ nomeAllenatore }}</strong> ti ha invitato a diventare il tuo allenatore.
                </p>
                <p>
                    Se accetti, potrà vedere i tuoi dati e pianificare i tuoi allenamenti.
                    Finché non rispondi non ha accesso a nulla. Puoi sempre disconnetterlo in seguito.
                </p>
                <p v-if="errore" class="error--text">{{ errore }}</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="inCorso" @click="rispondi(false)">Rifiuta</v-btn>
                <v-btn color="primary" text :disabled="inCorso" @click="rispondi(true)">Accetta</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from '@mixins/api.js';

const endpoint = `${process.env.VUE_APP_API_BASE_URL}/api/v2/allenatore_atleta.php`;

// Dopo una chiusura senza risposta la richiesta viene riproposta dopo questo intervallo.
// L'istante di chiusura e' in localStorage, cosi' il timeout vale anche ricaricando
// l'app, non solo finche' il componente resta montato.
const RIPROPOSTA_MS = 5 * 60 * 1000;
const STORAGE_KEY = 'richiestaAbbinamentoChiusa';

function leggiChiusura() {
    try {
        return Number(localStorage.getItem(STORAGE_KEY)) || 0;
    } catch (e) {
        return 0;
    }
}

function scriviChiusura(ts) {
    try {
        if (ts) {
            localStorage.setItem(STORAGE_KEY, String(ts));
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        // storage non disponibile: il timer in memoria basta comunque
    }
}

export default {
    name: 'MspRichiestaAbbinamento',
    data() {
        return {
            visible: false,
            richieste: [],
            inCorso: false,
            errore: '',
            timer: null,
        };
    },
    computed: {
        corrente() {
            return this.richieste[0] || null;
        },
        nomeAllenatore() {
            if (!this.corrente) return '';
            return `${this.corrente.allenatore_nome || ''} ${this.corrente.allenatore_cognome || ''}`.trim();
        },
    },
    watch: {
        // un invito arrivato a app gia' aperta compare al cambio di pagina
        '$route'() {
            this.controlla();
        },
    },
    mounted() {
        this.programma(Math.max(0, leggiChiusura() + RIPROPOSTA_MS - Date.now()));
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        programma(ritardo) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.load(), ritardo);
        },
        controlla() {
            if (this.visible) return;
            this.programma(Math.max(0, leggiChiusura() + RIPROPOSTA_MS - Date.now()));
        },
        async load() {
            if (this.visible) return;
            const result = await api(`${endpoint}?richieste`, 'GET');
            const richieste = (result && result.success) ? result.data : null;
            if (!richieste || !richieste.length) return;
            this.richieste = richieste;
            this.errore = '';
            this.visible = true;
        },
        async rispondi(accetta) {
            if (!this.corrente || this.inCorso) return;
            this.inCorso = true;
            this.errore = '';
            const azione = accetta ? 'accetta' : 'rifiuta';
            const result = await api(`${endpoint}?id=${this.corrente.id}&${azione}`, 'PUT');
            this.inCorso = false;
            if (!result || !result.success) {
                this.errore = 'Operazione non riuscita, riprova.';
                return;
            }
            // aggiorna l'elenco nello store (letto dalla pagina Abbinamenti)
            this.$store.dispatch('utente/loadAbbinamenti');
            this.richieste.shift();
            if (!this.richieste.length) {
                scriviChiusura(0);
                this.visible = false;
            }
        },
        // tap fuori / ESC senza aver risposto: riproposta dopo RIPROPOSTA_MS
        onDismiss() {
            this.visible = false;
            scriviChiusura(Date.now());
            this.programma(RIPROPOSTA_MS);
        },
    },
};
</script>
